import { alpha } from '@material-ui/core/styles'; // ----------------------------------------------------------------------

export var Backdrop = function Backdrop(_ref) {
  var theme = _ref.theme;
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(theme.palette.grey[900], 0.72)
        }
      }
    }
  };
};